import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useUserSettingsSync } from "../../hooks/use-user-settings-sync.js";
import { Footer } from "./footer.js";
import { Header } from "./header.js";

type Props = { children: ReactNode };

// Docs gets a wider container for its sidenav layout. The home page gets
// none: its workspace spans up to 120rem, and home.tsx centres everything
// around it at 5xl itself - a breakout from inside a 5xl container would
// need 100vw arithmetic, which counts the scrollbar and scrolls sideways.
// Every other route, including pricing's comparison table, stays at the
// reading-comfortable 5xl width that the footer also uses.
export function widthClassFor(pathname: string): string {
  if (/^\/(?:de|en)?\/?$/.test(pathname)) return "";
  return pathname.endsWith("/docs") ? "max-w-6xl" : "max-w-5xl";
}

export function Shell({ children }: Props) {
  useUserSettingsSync();
  const { pathname } = useLocation();
  const widthClass = widthClassFor(pathname);
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <Header />
      <main className={`mx-auto w-full ${widthClass} flex-1 px-4 py-8`}>{children}</main>
      <Footer />
    </div>
  );
}
